import { createModel } from 'hox';
import { useState, useEffect } from 'react';
import {
	IItemDetailList,
	IMaintenanceDetail,
	IMaterialDetailList,
	OtherItemDetailList
} from './MaintenanceType';
import { maintenanceService } from './MaintenanceService';
import { ciApi } from '@/utils/ciHttpRequest'

export const useMaintenanceDetailsModel = createModel(function () {

	//查看详情form
	const [tradeCode, setTradeCode] = useState<string>("");
	const [detailLookForm, setDetailLookForm] = useState<IMaintenanceDetail>({});

	//项目详情列表
	const [itemDetail, setItemDetail] = useState<IItemDetailList[]>([]);
	const [itemDetailVisible, setItemDetailVisible] = useState<boolean>(false);
	//维修用料详情列表
	const [detailMaterialList, setDetailMaterialList] = useState<IMaterialDetailList[]>([]);
	const [detailMaterialListVisible, setDetailMaterialListVisible] = useState<boolean>(false);
	//维修用料详情列表
	const [otherItemDetailList, setOtherItemDetailList] = useState<OtherItemDetailList[]>([]);
	const [otherItemDetailListVisible, setOtherItemDetailListVisible] = useState<boolean>(false);

	const getTreeNodeValue = (list: any, code?: string): any => {
		return list.find((i) => i.dictCode === code)?.dictName
	}

	//维修单信息
	const getDetailOne = async (id: any) => {
		let { retData } = await maintenanceService.one(id);
		if (retData != null) {
			let { retData: ciDict } = await ciApi.ciDict()
			const newFrom: IMaintenanceDetail = {
				...retData,
				repairContactName: (retData.senderRepairUserName ?? "") + " " + (retData.senderRepairUserPhone ?? ""),
				serviceMethod: getTreeNodeValue(ciDict, retData.serviceMethod) ?? "",
				serviceType: getTreeNodeValue(ciDict, retData.serviceType) ?? "",
				faultClassification: getTreeNodeValue(ciDict, retData.faultClassification) ?? "",
				customerVehicleMileage: (retData.customerVehicleMileage ?? "0") as string + "  KM",
				mileage: (retData.mileage ?? "0") as string + "  KM",
				orderType: getTreeNodeValue(ciDict, retData.orderType) ?? "",
			};
			setDetailLookForm(newFrom);

			setItemDetailVisible(false);
			setDetailMaterialListVisible(false);
			setOtherItemDetailListVisible(false);
			itemDetailList(retData.id as string);
			materialList(retData.id as string);
			otherItemList(retData.id as string);
		}
	};


	//维修项目
	const itemDetailList = async (id: string) => {
		let param = { "pageSize": 1000, "searchItem": { "orderId": id, "serviceNature": ["016002", "016003", "016004"] } };
		let { retData } = await maintenanceService.itemList(param);
		const { list } = retData;
		setItemDetail(list);
		if (list != null && list.length > 0) {
			setItemDetailVisible(true);
		}
	};

	//维修物料
	const materialList = async (id: string) => {
		let param = { "pageSize": 1000, "searchItem": { "orderId": id, "serviceNature": ["016002", "016003", "016004"] } }
		let { retData } = await maintenanceService.materialList(param);
		const { list } = retData;
		let newList = list.map(item => ({
			...item,
			totalCount: item.materialAmount,
			actualMoney: item.actualAmount,
			availableUseNum: (item.remainingNum ?? 0) + (item.materialNumber ?? 0),
		}));
		setDetailMaterialList(newList);

		if (list != null && list.length > 0) {
			setDetailMaterialListVisible(true);
		}
	};

	//其他项目
	const otherItemList = async (id: string) => {
		let param = { "pageSize": 1000, "searchItem": { "orderId": id } }
		let { retData } = await maintenanceService.otherItemDetailList(param);
		const { list } = retData;
		setOtherItemDetailList(list);

		if (list != null && list.length > 0) {
			setOtherItemDetailListVisible(true);
		}
	};


	return {
		setTradeCode,
		getDetailOne,
		tradeCode,
		detailLookForm,
		itemDetail,
		itemDetailVisible,
		detailMaterialList,
		detailMaterialListVisible,
		otherItemDetailList,
		otherItemDetailListVisible
	};

});
